module.exports = __webpack_public_path__ + "img/hero-top.af30d1bf.png";